import { useEffect } from "react";
import { setTitle } from "../helpers/title";
import { Helmet } from "react-helmet";

function PressReleases() {
	useEffect(() => {
		setTitle(`MyHealthily - Press Releases`);
	}, []);
	
	return (
		<div role="main" className="main">

			<section className="page-header page-header-classic page-header-md">
				<div className="container">
					<div className="row">
						<div className="col-md-8 order-2 order-md-1 align-self-center p-static">
							<h1 data-title-border>Press Releases</h1>
						</div>
					</div>
				</div>
			</section>
			
			<div className="container container-xl-custom py-1 my-1">
				<div className="row justify-content-center">
					<div className="col-xl-9 text-center">
						<p className="line-height-9 text-4 opacity-9 appear-animation"
						   data-appear-animation="fadeInUpShorter" data-appear-animation-delay="200">Checkout the latest and archived press releases from MyHealthily.</p>
					</div>
				</div>
			</div>

			<div className="container py-4">
				<div className="row">
					<div className="col">
						<div className="blog-posts">
							<div className="row">
							
								<div className="col-md-4">
									<article className="post post-medium border-0 pb-0 mb-5">
										<div className="post-content">
											<h2 className="font-weight-semibold text-5 line-height-3 mt-3 mb-2">MyHealthily Named in Artificial Intelligence Awards</h2>
											<h6>(2/20/24)</h6>
											<p>MyHealthily was honored to be named Most Innovative Workflow Management Platform Provider - East Coast USA!.</p>
											<div className="post-meta">
												<span className="d-block mt-2"><a href="downloads/MyHealthily-Press Release-AI-Awards-2-20-24.pdf" className="btn btn-xs btn-light text-1 text-uppercase" target="_blank">Download PDF</a> &nbsp; <a href="https://www.prlog.org/13007991-myhealthily-named-in-artificial-intelligence-awards.html" className="btn btn-xs btn-light text-1 text-uppercase" target="_blank">View Release</a></span>
											</div>
										</div>
									</article>
								</div>
							
								<div className="col-md-4">
									<article className="post post-medium border-0 pb-0 mb-5">
										<div className="post-content">
											<h2 className="font-weight-semibold text-5 line-height-3 mt-3 mb-2">Delta Dental Added to Platform</h2>
											<h6>(12/4/23)</h6>
											<p>Agents can now quote both Delta Dental and DeltaVision for small businesses on the MyHealthily platform.</p>
											<div className="post-meta">
												<span className="d-block mt-2"><a href="downloads/MyHealthily-Press Release-Delta-Dental-12.4.23.pdf" className="btn btn-xs btn-light text-1 text-uppercase" target="_blank">Download PDF</a> &nbsp; <a href="https://www.prlog.org/12996831-myhealthily-announces-delta-dental.html" className="btn btn-xs btn-light text-1 text-uppercase" target="_blank">View Release</a></span>
											</div>
										</div>
									</article>
								</div>

								<div className="col-md-4">
									<article className="post post-medium border-0 pb-0 mb-5">
										<div className="post-content">
											<h2 className="font-weight-semibold text-5 line-height-3 mt-3 mb-2">Sentara Added to Platform</h2>
											<h6>(11/29/23)</h6>
											<p>We're excited to welcome Sentara to the MyHealthily platform to offer even more plans for small groups.</p>
											<div className="post-meta">
												<span className="d-block mt-2"><a href="downloads/MyHealthily-Press-Release-Sentara-11.29.23.pdf" className="btn btn-xs btn-light text-1 text-uppercase" target="_blank">Download PDF</a> &nbsp; <a href="https://www.prlog.org/12996164-myhealthily-welcomes-sentara-to-platform.html" className="btn btn-xs btn-light text-1 text-uppercase" target="_blank">View Release</a></span>
											</div>
										</div>
									</article>
								</div>

								<div className="col-md-4">
									<article className="post post-medium border-0 pb-0 mb-5">
										<div className="post-content">
											<h2 className="font-weight-semibold text-5 line-height-3 mt-3 mb-2">BEST Life & Health Added to Platform</h2>
											<h6>(11/27/23)</h6>
											<p>MyHealthily announces the addition of BEST Life and Health Insurance Company, to their platform.</p>
											<div className="post-meta">
												<span className="d-block mt-2"><a href="downloads/MyHealthily-Press_Release-Best-Life.pdf" className="btn btn-xs btn-light text-1 text-uppercase" target="_blank">Download PDF</a> &nbsp; <a href="https://www.prlog.org/12995761-myhealthily-adds-best-life-health-insurance-company.html" className="btn btn-xs btn-light text-1 text-uppercase" target="_blank">View Release</a></span>
											</div>
										</div>
									</article>
								</div>

								<div className="col-md-4">
									<article className="post post-medium border-0 pb-0 mb-5">
										<div className="post-content">
											<h2 className="font-weight-semibold text-5 line-height-3 mt-3 mb-2">EBenefitsHub Announces MyHealthily as Exclusive National CorePartner</h2>
											<h6>(11/8/23)</h6>
											<p>EBenefitsHub announces MyHealthily as their Exclusive National Core Partner.</p>
											<div className="post-meta">
												<span className="d-block mt-2"><a href="downloads/MyHealthily-Press-Release-EBenefits-Hub-11.6.2023.pdf" className="btn btn-xs btn-light text-1 text-uppercase" target="_blank">Download PDF</a> &nbsp; <a href="https://www.myebenefitshub.com/ebenefitshub-announces-myhealthily-as-exclusive-national-corepartner" className="btn btn-xs btn-light text-1 text-uppercase" target="_blank">View Release</a></span>
											</div>
										</div>
									</article>
								</div>
							
								<div className="col-md-4">
									<article className="post post-medium border-0 pb-0 mb-5">
										<div className="post-content">
											<h2 className="font-weight-semibold text-5 line-height-3 mt-3 mb-2">New World Report Software & Technology Award</h2>
											<h6>(11/6/23)</h6>
											<p>MyHealthily has been named Best Healthcare Insurance Broker Software Developer in 2023.</p>
											<div className="post-meta">
												<span className="d-block mt-2"><a href="downloads/MyHealthily-Press-Release-New-World-Report11.6.23.pdf" className="btn btn-xs btn-light text-1 text-uppercase" target="_blank">Download PDF</a> &nbsp; <a href="https://www.prlog.org/12992757-myhealthily-wins-new-world-report-software-technology-award.html" className="btn btn-xs btn-light text-1 text-uppercase" target="_blank">View Release</a></span>
											</div>
										</div>
									</article>
								</div>

								<div className="col-md-4">
									<article className="post post-medium border-0 pb-0 mb-5">
										<div className="post-content">
											<h2 className="font-weight-semibold text-5 line-height-3 mt-3 mb-2">MyHealthily Launches OneAmerica Plans</h2>
											<h6>(7/18/23)</h6>
											<p>OneAmerica joins the MyHealthily platform to offer life and disability plan options.</p>
											<div className="post-meta">
												<span className="d-block mt-2">
												<a href="https://www.prlog.org/12974344-myhealthily-launches-oneamerica-plans.html" className="btn btn-xs btn-light text-1 text-uppercase" target="_blank">View Release</a></span>
											</div>
										</div>
									</article>
								</div>

								<div className="col-md-4">
									<article className="post post-medium border-0 pb-0 mb-5">
										<div className="post-content">
											<h2 className="font-weight-semibold text-5 line-height-3 mt-3 mb-2">MyHealthily partners with VAULT Strategies</h2>
											<h6>(6/6/23)</h6>
											<p>VAULT Strategies offers value through cost reduction, product innovation, customization, and improved health outcomes.</p>
											<div className="post-meta">
												<span className="d-block mt-2"><a href="downloads/MyHealthily-Press-Release-Vault-6.6.23.pdf" className="btn btn-xs btn-light text-1 text-uppercase" target="_blank">Download PDF</a></span>
											</div>
										</div>
									</article>
								</div>

								<div className="col-md-4">
									<article className="post post-medium border-0 pb-0 mb-5">
										<div className="post-content">
											<h2 className="font-weight-semibold text-5 line-height-3 mt-3 mb-2">New Illustrative Level Funding Feature for Small Groups</h2>
											<h6>(4/4/23)</h6>
											<p>Agents can now generate multiple healthcare estimates from multiple national medically underwritten carriers.</p>
											<div className="post-meta">
												<span className="d-block mt-2"><a href="downloads/MyHealthily-Press-Release-Illustrative-Level-Funding-4.4.2023.pdf" className="btn btn-xs btn-light text-1 text-uppercase" target="_blank">Download PDF</a></span>
											</div>
										</div>
									</article>
								</div>
								
								<div className="col-md-4">
									<article className="post post-medium border-0 pb-0 mb-5">
										<div className="post-content">
											<h2 className="font-weight-semibold text-5 line-height-3 mt-3 mb-2">Lensabl+ Added to Platform</h2>
											<h6>(2/24/23)</h6>
											<p>Lensabl+ offerings are available when shopping for ancillary vision coverage on the MyHealthily platform.</p>
											<div className="post-meta">
												<span className="d-block mt-2"><a href="downloads/MyHealthily-Press-Release-Lensabl-2.23.23.pdf" className="btn btn-xs btn-light text-1 text-uppercase" target="_blank">Download PDF</a></span>
											</div>
										</div>
									</article>
								</div>

								<div className="col-md-4">
									<article className="post post-medium border-0 pb-0 mb-5">
										<div className="post-content">
											<h2 className="font-weight-semibold text-5 line-height-3 mt-3 mb-2">New Benefits Partnership</h2>
											<h6>(1/3/23)</h6>
											<p>MyHealthily announces New Benefits suite to be included in level-funded coverage options.</p>
											<div className="post-meta">
												<span className="d-block mt-2"><a href="downloads/MyHealthily-Press-Release-New-Benefits-Launch-1.3.23.pdf" className="btn btn-xs btn-light text-1 text-uppercase" target="_blank">Download PDF</a> &nbsp; <a href="https://www.prlog.org/12945869-myhealthily-announces-new-benefits-partnership.html" className="btn btn-xs btn-light text-1 text-uppercase" target="_blank">View Release</a></span>
											</div>
										</div>
									</article>
								</div>

								<div className="col-md-4">
									<article className="post post-medium border-0 pb-0 mb-5">
										<div className="post-content">
											<h2 className="font-weight-semibold text-5 line-height-3 mt-3 mb-2">Multiple Underwritten Quotes with 1 Questionnaire</h2>
											<h6>(1/19/23)</h6>
											<p>MyHealthily announces the release of a new medically underwritten questionnaire. This one form completes five carrier specific medically underwritten questionnaires.</p>
											<div className="post-meta">
												<span className="d-block mt-2"><a href="downloads/MyHealthily-Press-Release-Multiple-Underwritten-Quotes-1.19.23.pdf" className="btn btn-xs btn-light text-1 text-uppercase" target="_blank">Download PDF</a> &nbsp; <a href="https://www.prlog.org/12947919-myhealthily-to-release-multi-carrier-medical-questionnaire.html" className="btn btn-xs btn-light text-1 text-uppercase" target="_blank">View Release</a></span>
											</div>
										</div>
									</article>
								</div>

								<div className="col-md-4">
									<article className="post post-medium border-0 pb-0 mb-5">
										<div className="post-content">
											<h2 className="font-weight-semibold text-5 line-height-3 mt-3 mb-2">New Ancillary Filters</h2>
											<h6>(12/22/22)</h6>
											<p>MyHealthily announces their full-service platform now includes filtering options for all ancillary coverage.</p>
											<div className="post-meta">
												<span className="d-block mt-2"><a href="downloads/MyHealthily-Press-Release-Ancillary-Filters-12.22.22.pdf" className="btn btn-xs btn-light text-1 text-uppercase" target="_blank">Download PDF</a> &nbsp; <a href="https://www.prlog.org/12944818-myhealthily-launches-ancillary-filtering-options.html" className="btn btn-xs btn-light text-1 text-uppercase" target="_blank">View Release</a></span>
											</div>
										</div>
									</article>
								</div>

								<div className="col-md-4">
									<article className="post post-medium border-0 pb-0 mb-5">
										<div className="post-content">
											<h2 className="font-weight-semibold text-5 line-height-3 mt-3 mb-2">Age Banded</h2>
											<h6>(11/22/22)</h6>
											<p>MyHealthily announces their full-service platform now includes age banded pricing for all fully-insured plans.</p>
											<div className="post-meta">
												<span className="d-block mt-2"><a href="downloads/MyHealthily-Press-Release-Age-Banding-11.22.22.pdf" className="btn btn-xs btn-light text-1 text-uppercase" target="_blank">Download PDF</a></span>
											</div>
										</div>
									</article>
								</div>

								<div className="col-md-4">
									<article className="post post-medium border-0 pb-0 mb-5">
										<div className="post-content">
											<h2 className="font-weight-semibold text-5 line-height-3 mt-3 mb-2">Beam Benefits</h2>
											<h6>(10/14/22)</h6>
											<p>MyHealthily announces the release of ancillary benefits through a partnership with Beam Benefits for dental and vision.</p>
											<div className="post-meta">
												<span className="d-block mt-2"><a href="downloads/MyHealthily-Press-Release-Beam-Benefits-10.10.22.pdf" className="btn btn-xs btn-light text-1 text-uppercase" target="_blank">Download PDF</a></span>
											</div>
										</div>
									</article>
								</div>

								<div className="col-md-4">
									<article className="post post-medium border-0 pb-0 mb-5">
										<div className="post-content">
											<h2 className="font-weight-semibold text-5 line-height-3 mt-3 mb-2">Partnership with Aflac</h2>
											<h6>(8/23/22)</h6>
											<p>MyHealthily announces the release of ancillary and worksite benefits through an exclusive partnership with Aflac.</p>
											<div className="post-meta">
												<span className="d-block mt-2"><a href="downloads/MyHealthily-Press-Release-Aflac-8.23.22.pdf" className="btn btn-xs btn-light text-1 text-uppercase" target="_blank">Download PDF</a> &nbsp; <a href="https://www.prlog.org/12930017-myhealthily-announces-aflac-partnership-for-small-group-health.html" className="btn btn-xs btn-light text-1 text-uppercase" target="_blank">View Release</a></span>
											</div>
										</div>
									</article>
								</div>

								<div className="col-md-4">
									<article className="post post-medium border-0 pb-0 mb-5">
										<div className="post-content">
											<h2 className="font-weight-semibold text-5 line-height-3 mt-3 mb-2">Platform Announcement</h2>
											<h6>(1/10/22)</h6>
											<p>MyHealthily announces the launch of their proprietary platform for agents and brokers to quote, enroll, and service small group benefits.</p>
											<div className="post-meta">
												<span className="d-block mt-2"><a href="downloads/MyHealthily-Press-Release-Agent-Broker-1.10.22.pdf" className="btn btn-xs btn-light text-1 text-uppercase" target="_blank">Download PDF</a> &nbsp; <a href="https://www.prlog.org/12900223-agents-save-days-of-work-with-myhealthily-platform.html" className="btn btn-xs btn-light text-1 text-uppercase" target="_blank">View Release</a></span>
											</div>
										</div>
									</article>
								</div>

							</div>
						</div>
					</div>
				</div>
			</div>
			<Helmet>
				<script src={`${process.env.PUBLIC_URL}js/custom.js`}></script>
				<script src={`${process.env.PUBLIC_URL}js/theme.init.js`}></script>
				<script src="https://cdn.pagesense.io/js/candorusa/60482c77eb8e406a9ccd3127bafff935.js"></script>
			</Helmet>
		</div>
	);
}

export default PressReleases;
